import AbstractService, {
  InterfacePartner,
  ServicePartner,
  ModelPartner
} from "./AbstractService";

/**
 * AuthService
 */
export default class PartnerService extends AbstractService implements InterfacePartner {
  /**
   * ServiceAuth
   */
  static service: ServicePartner;

  /**
   * constructor
   */
  constructor() {
    super();

    PartnerService.service = this.getApi().getServicePartner();
  }

  /**
   * create
   * @param partner
   */
  create(partner: ModelPartner): Promise<ModelPartner> {
    return PartnerService.service.create(partner);
  }

  /**
   * getAll
   */
  getAll(): Promise<ModelPartner[]> {
    return PartnerService.service.getAll();
  }

  /**
   * getById
   * @param id
   */
  getById(id: string): Promise<ModelPartner> {
    return PartnerService.service.getById(id);
  }

  /**
   * update
   * @param id
   * @param partner
   */
  update(id: string, partner: ModelPartner): Promise<ModelPartner> {
    return PartnerService.service.update(id, partner);
  }

  /**
   * getPublicActive
   * @param hashId
   * @param name
   */
  getPublicActive(): Promise<Array<{ name: string; hashId: string }>> {
    return PartnerService.service.getPublicActive();
  }

  /**
   * getPublicActiveList
   * public paginated (datatable) list of all active partners
   * @param tableParameter
   */
  getPublicActiveList(tableParameter: { [key: string]: any } = {}): Promise<any> {
    return PartnerService.service.getHttpService()
      .get('/partner/publicActiveList', tableParameter, { "Datatable": "true" })
      .then((response) => response.data);
  }

  /**
   * getCompanyLogoUrl
   * @param hashId
   */
  getCompanyLogoUrl(hashId: string): string {
    return PartnerService.service.getCompanyLogoUrl(hashId);
  }
}
